import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import colors from "../theme/colors";

// Badge "Deposit secured by ..." facon Smily.
// provider: "tyllt" | "airbnb"
// onRemove: callback optionnel -> affiche une croix rouge "Retirer" (admin)
const PROVIDERS = {
  tyllt: { color: colors.tyllt, label: "Deposit secured by Tyllt" },
  airbnb: { color: colors.airbnb, label: "Deposit secured by Airbnb" },
};

function DepositBadge({ provider = "tyllt", onRemove }) {
  const conf = PROVIDERS[provider];
  if (!conf) return null;
  return (
    <div
      style={{
        marginTop: 6,
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        minHeight: 32,
        alignItems: "center",
        gap: 8,
        padding: onRemove ? "4px 8px 4px 6px" : "4px 12px 4px 6px",
        border: `1px solid ${colors.border}`,
        borderRadius: 8,
        backgroundColor: colors.white,
        fontSize: 13,
        fontWeight: 500,
        color: colors.text,
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 22,
          height: 22,
          borderRadius: 6,
          backgroundColor: conf.color,
        }}
      >
        <FontAwesomeIcon icon={faShieldHalved} style={{ color: colors.white, fontSize: 12 }} />
      </span>
      {conf.label}
      {onRemove && (
        <span
          onClick={onRemove}
          title="Retirer"
          style={{
            marginLeft: "auto",
            padding: "0 3px",
            color: colors.danger,
            fontWeight: 700,
            fontSize: 15,
            lineHeight: 1,
            cursor: "pointer",
          }}
        >
          ✕
        </span>
      )}
    </div>
  );
}

export default DepositBadge;
